import { fromJS } from 'immutable';
import _ from 'lodash';
import normaliseResponse from 'utils/normaliseResponse';

import * as constants from 'actions/instances/constants';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_INSTANCES_SUCCESS: {
      const { instances, projectId } = action;

      const prevAllIds = state.get('allIds') || [];

      const normalisedResponse = normaliseResponse(instances);
      const { byId } = normalisedResponse;
      const allIdsByProject = normalisedResponse.allIds;
      const allIds = prevAllIds.concat(
        allIdsByProject.filter((id) => prevAllIds.indexOf(id) < 0)
      );

      // Augment instances with instance status
      const augmentedInstancesById = _.mergeWith(
        state.get('byId')?.toJS(),
        byId,
        (objValue, srcValue, key) => {
          if (key === 'groups') {
            return srcValue;
          }
        }
      );

      return state
        .set('byId', fromJS(augmentedInstancesById))
        .set('allIds', fromJS(allIds))
        .setIn(['byProjectId', `${projectId}`], fromJS(allIdsByProject));
    }

    case constants.GET_INSTANCES_STATUSES_SUCCESS: {
      const { instancesStatuses, projectId } = action;

      const prevAllIds = state.get('allIds') || [];

      const normalisedResponse = normaliseResponse(instancesStatuses);
      const { byId } = normalisedResponse;
      const allIdsByProject = normalisedResponse.allIds;
      const allIds = prevAllIds.concat(
        allIdsByProject.filter((id) => prevAllIds.indexOf(id) < 0)
      );

      return state
        .mergeDeep(fromJS({ byId }))
        .set('allIds', fromJS(allIds))
        .setIn(['byProjectId', `${projectId}`], fromJS(allIdsByProject));
    }

    case constants.UPDATE_INSTANCE_SUCCESS:
      // It only updates existing instances, doesn't create new ones
      // It doesn't change anything in byProjectId
      return state.updateIn(
        ['byId', `${action.instanceId}`],
        (prevInstance) =>
          prevInstance && prevInstance.merge(fromJS(action.instance))
      );

    default:
      return state;
  }
};
